<div
  class="dropdown"
  [class.modal]="modal"
  >
  <div [attr.aria-label]="ariaLabel" class="item current" (click)="toggle()" onkeydown="" tabindex="0" (keyup.enter)="toggle()" (keyup.esc)="close()">
    <app-icon [class.hidden]="!showIcon" [icon]="icon"></app-icon>
    <ng-container *ngTemplateOutlet="template; context: {item: getSelectedItem()}"></ng-container>
    <app-icon [icon]="active ? 'chevron-up' : 'chevron-down'"></app-icon>
  </div>

  <div class="option-list" [class.show]="this.active">
    <div class="scrollable-area">
      @for (item of this.items; track item) {
        <div
          class="item"
          [class.selected]="this.getSelectedItem().value === item.value"
          (click)="this.select(item)"
          tabindex="0"
          (keyup.enter)="this.select(item);this.close()"
          (keyup.esc)="this.close()"
          [attr.aria-label]="item.label"
          >
          <ng-container *ngTemplateOutlet="template; context: {item: item}"></ng-container>
          <app-icon icon="circle-check" type="solid"></app-icon>
        </div>
      }
    </div>
  </div>
</div>

<ng-template #template let-item="item">
  <div [innerHTML]="item.label"></div>
</ng-template>
